export const FIRST_NAME_MAX_LENGTH = 256;
export const LAST_NAME_MAX_LENGTH = 256;

export function validateFirstName(value: string): string {
    // Cannot be empty
    if (value.length === 0) {
        return 'shared.fields.first_name.error_required';
    }

    // Cannot be greater than 256 characters
    if (value.length > FIRST_NAME_MAX_LENGTH) {
        return 'shared.fields.first_name.error_too_long';
    }

    // Cannot contain numbers
    if (value.match(/[0-9]/)) {
        return 'shared.fields.first_name.error_no_numbers';
    }

    return '';
}

export function validateLastName(value: string): string {
    // Cannot be empty
    if (value.length === 0) {
        return 'shared.fields.last_name.error_required';
    }

    // Cannot be greater than 256 characters
    if (value.length > LAST_NAME_MAX_LENGTH) {
        return 'shared.fields.last_name.error_too_long';
    }

    // Cannot contain numbers
    if (value.match(/[0-9]/)) {
        return 'shared.fields.last_name.error_no_numbers';
    }

    return '';
}
